'use client';
import { ReactComponent } from './alert-xs.svg';
export const AlertIconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=alert-xs.js.map